import React, { useEffect, useState } from "react";
import "../noreba.css";

function Circulares() {
  const [lista, setLista] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch("/api/normativa/circulares")
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setLista)
      .catch(() => setError("No se pudieron cargar los documentos"));
  }, []);

  const formatFecha = (v) => {
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("es-ES");
  };

  // 🔧 Limpia el nombre al mostrar y descargar
  const cleanFilename = (filename = "") => filename.replace(/^\d+-/, "");

  const descargar = async (item) => {
    const r = await fetch(`/api/normativa/circulares/${item._id}?download=1`);
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    // ✅ solo descargamos el texto después del primer guion
    a.download = cleanFilename(item.filename || "circulares") + ".pdf";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="noreba-wrap">
      <header className="noreba-header"><h1>Circulares</h1></header>
      {error && <div className="noreba-error">{error}</div>}
      <section className="noreba-list">
        {lista.length === 0 && <div className="noreba-empty">No hay documentos</div>}
        {lista.map((it) => (
          <article key={it._id} className="noreba-item">
            <div className="info">
              {/* ✅ muestra solo la parte limpia */}
              <div className="title">{it.nombre || cleanFilename(it.filename)}</div>
              <div className="meta">
                <span>{(it.length / 1024).toFixed(1)} KB</span> • <span>{formatFecha(it.fecha || it.uploadDate)}</span>
              </div>
            </div>
            <div className="actions">
              <button className="btn-view" onClick={() => descargar(it)}>Descargar</button>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
export default Circulares;
